import { Accordion, AccordionSummary, AccordionDetails, Grid, Table, TableBody, Paper, TableCell, TableContainer, TableHead, TableRow, FormControl, InputLabel, Select, MenuItem, RadioGroup, FormControlLabel, Radio } from "@material-ui/core"
import { useSelector, useDispatch } from "react-redux"
import { catTipoPago } from "../../../../constant/catTipoPago"
import { formatDinero } from "./../../../../utils/formatDinero"
import { FormatoFechaIso, formatAddMonthformat, formatSubDaysIso } from "../../../../utils/FormatFecha"
import { makeStyles } from "@material-ui/core"
import { useEffect } from "react"
import { obtenerMensualidadesAction, obtenerBancosAction, obtenerBancoMensualidad, obtenerPlazosBanoAction, addBancoAction, addBancoMensualidadAction, obtenerPlanPagosHibrido } from "../../../../ducks/cotizadorPaqueteDuck"
import { catCotizador } from "../../../../constant/constantes"
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'

export const VPagosStyle = makeStyles((theme) => ({
}))

const VPagos = () => {
    const { noMensualidadHibrido, mensualidadHibrido, fechaSalidaFormat, banco, metodoPago, listaPlazosBanco, mensualidades, montoTotal, paquete, fechaSalida, listaBancos, bancoMensualidad } = useSelector(store => store.cotizadorPaquete)
    const classes = VPagosStyle()
    const dispatch = useDispatch()
    useEffect(() => {
        const validar = () => {
            let montoFinal = montoTotal
            let fechaFinal = FormatoFechaIso({ date: fechaSalidaFormat, formato: "MMddyyyy" })
            if (Number(metodoPago) === catTipoPago.HIBRIDO) {
                montoFinal = montoTotal * catCotizador.PORCENTAJE_MENSUALIDAD_HIBRIDO
                fechaFinal = formatAddMonthformat({ months: catCotizador.CANTIDAD_PAGOS_ADIFERIR })
            }
            dispatch(obtenerMensualidadesAction({ fecha: fechaFinal, monto: montoFinal }))
        }
        if (fechaSalidaFormat !== "0" && montoTotal !== 0)
            validar()
        dispatch(obtenerBancosAction())
    }, [dispatch, fechaSalidaFormat, montoTotal, metodoPago])

    useEffect(() => {
        const obtener = () => {
            let montoFinal = montoTotal
            if (Number(metodoPago) === catTipoPago.HIBRIDO && noMensualidadHibrido > 0) {
                let fechaFinal = FormatoFechaIso({ date: fechaSalidaFormat, formato: "MMddyyyy" })
                dispatch(obtenerPlanPagosHibrido({
                    FecSalida: fechaFinal,
                    IdBanco: banco,
                    NumPagoCIE: noMensualidadHibrido,
                    PorCIE: catCotizador.PORCENTAJE_MENSUALIDAD_HIBRIDO * 100,
                    PorTC: catCotizador.PORCENTAJE_TARJETA_CREDITO_HIBRIDO * 100,
                    PrecioPaquete: montoFinal
                }))
                montoFinal = montoTotal * catCotizador.PORCENTAJE_TARJETA_CREDITO_HIBRIDO
            }
            dispatch(obtenerBancoMensualidad({ IdBanco: banco }))
            dispatch(obtenerPlazosBanoAction({ IdBanco: banco, PrecioPaquete: montoFinal }))
        }
        if (banco !== 0)
            obtener()
    }, [dispatch, banco, montoTotal, metodoPago, fechaSalidaFormat])


    const handleChangeSelectValue = (event) => {
        dispatch(addBancoAction({ banco: event.target.value }))
        dispatch(addBancoMensualidadAction({ bancoMensualidad: "0" }))
    }
    const handleChangeRadioValue = (event) => {
        dispatch(addBancoMensualidadAction({ bancoMensualidad: event.target.value }))
    }
    if (Number(metodoPago) !== catTipoPago.NOAPLICA && montoTotal > 0) return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                {
                    (Number(metodoPago) === catTipoPago.TARJETA_CREDITO) &&
                    <Grid container style={{ margin: "1rem" }}>
                        <Grid item xs={12}>
                            <h5>Tarjeta de credito</h5>
                        </Grid>
                        <Grid item xs={4}>
                            <FormControl variant="outlined" style={{ width: "98%", marginBottom: "12px" }}>
                                <InputLabel id="lBanco">Banco</InputLabel>
                                <Select
                                    labelId="lBanco"
                                    id="SBanco"
                                    name="banco"
                                    onChange={handleChangeSelectValue}
                                    label="Banco"
                                    value={banco}
                                >
                                    <MenuItem value="0" disabled>
                                        {"Seleccione una opción"}
                                    </MenuItem>
                                    {listaBancos.map((banco, index) => (
                                        <MenuItem key={banco.IdBanco} value={`${banco.IdBanco}`}>
                                            {`${banco.Nombre}`}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <TableContainer component={Paper}>
                                <Table className={classes.table} aria-label="simple table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align="center">Plazo</TableCell>
                                            <TableCell align="center">Por mes</TableCell>
                                            <TableCell align="center">Total</TableCell>
                                            <TableCell align="center"></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody component={RadioGroup} value={bancoMensualidad} onChange={handleChangeRadioValue}>
                                        {listaPlazosBanco.map((mensualidad, index) => (
                                            <TableRow key={mensualidad.IdBancoMensualidad}>
                                                <TableCell align="center"> {`${mensualidad.Mensualidad?.Cantidad} Meses`}</TableCell>
                                                <TableCell align="center">{formatDinero(mensualidad.PrecioFinal / Number(mensualidad.Mensualidad?.Cantidad))} {paquete?.Moneda?.Clave}</TableCell>
                                                <TableCell align="center">{formatDinero(mensualidad.PrecioFinal)} {paquete?.Moneda?.Clave}</TableCell>
                                                <TableCell align="center">
                                                    <FormControlLabel value={`${mensualidad.IdBancoMensualidad}`} control={<Radio />} />
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                        <Grid item={12}>
                            {
                                (Number(metodoPago) === catTipoPago.HIBRIDO) &&
                                <h5>Fecha pago: {formatSubDaysIso({ date: fechaSalidaFormat, days: 60, formato: "dd MMMM yyyy" })}</h5>
                            }
                        </Grid>
                    </Grid>
                }
            </Grid>
            <Grid item xs={12}>
                {
                    (Number(metodoPago) === catTipoPago.PLAN_PAGOS) &&
                    <Grid container style={{ margin: "1rem" }}>
                        <Grid item xs={12}>
                            <h5>Formato CIE</h5>
                            <h5>Total: {`${formatDinero((Number(metodoPago) === catTipoPago.HIBRIDO) ? montoTotal * catCotizador.PORCENTAJE_MENSUALIDAD_HIBRIDO : montoTotal)} ${paquete?.Moneda?.Clave}`}</h5>
                        </Grid>
                        <Grid item xs={12}>
                            <TableContainer component={Paper}>
                                <Table className={classes.table} aria-label="simple table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align="center">#</TableCell>
                                            <TableCell align="center">Fecha</TableCell>
                                            <TableCell align="center">Pago</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {mensualidades.map((row, index) => (
                                            <TableRow key={index}>
                                                <TableCell align="center">{index + 1}</TableCell>
                                                <TableCell align="center">{FormatoFechaIso({ date: row.FechaCorte, formato: "dd MMMM yyyy" })}</TableCell>
                                                <TableCell align="center">{formatDinero(row.MontoMensualidad)} {paquete?.Moneda?.Clave}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                    </Grid>
                }
            </Grid>
            <Grid item xs={12}>
                {
                    (Number(metodoPago) === catTipoPago.HIBRIDO) &&
                    <Grid container style={{ margin: "1rem" }}>
                        <Grid item xs={12}>
                            <h5>Hibrido</h5>
                        </Grid>
                        <Grid item xs={4}>
                            <FormControl variant="outlined" style={{ width: "98%", marginBottom: "12px" }}>
                                <InputLabel id="lBanco">Banco</InputLabel>
                                <Select
                                    labelId="lBanco"
                                    id="SBanco"
                                    name="banco"
                                    onChange={handleChangeSelectValue}
                                    label="Banco"
                                    value={banco}
                                >
                                    <MenuItem value="0" disabled>
                                        {"Seleccione una opción"}
                                    </MenuItem>
                                    {listaBancos.map((banco, index) => (
                                        <MenuItem key={banco.IdBanco} value={`${banco.IdBanco}`}>
                                            {`${banco.Nombre}`}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <RadioGroup value={bancoMensualidad} onChange={handleChangeRadioValue}>
                                {
                                    mensualidadHibrido.map((value, idnex) => {
                                        return (
                                            <Accordion key={value.IdBancoMensualidad}>
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    aria-label="Expand"
                                                    aria-controls="additional-actions3-content"
                                                    id={value.IdBancoMensualidad + "acordion"}
                                                >
                                                    <FormControlLabel
                                                        aria-label="Acknowledge"
                                                        onClick={(event) => event.stopPropagation()}
                                                        onFocus={(event) => event.stopPropagation()}
                                                        control={<Radio />}
                                                        value={`${value.IdBancoMensualidad}`}
                                                        label={`Plan a ${value.NumMenTC} Mensualidades`}
                                                    />
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <Table className={classes.table} aria-label="simple table">
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell align="center">#</TableCell>
                                                                <TableCell align="center">Fecha de pago</TableCell>
                                                                <TableCell align="center">Monto</TableCell>
                                                                <TableCell align="center">Tipo</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {value?.lPlanPago.map((mensualidad, index) => (
                                                                <TableRow key={index + 1}>
                                                                    <TableCell align="center"> {`${index + 1}`}</TableCell>
                                                                    <TableCell align="center">{FormatoFechaIso({date: mensualidad.FechaLimitePago , formato: "dd-MM-yyyy"})}</TableCell>
                                                                    <TableCell align="center">{formatDinero(mensualidad.Monto)} {paquete?.Moneda?.Clave}</TableCell>
                                                                    <TableCell align="center">{(mensualidad?.CatTipoPago?.IdCatTipoPago === 1) ? "CIE" : "TDC"}</TableCell>
                                                                </TableRow>
                                                            ))}
                                                        </TableBody>
                                                    </Table>
                                                </AccordionDetails>
                                            </Accordion>
                                        )
                                    })
                                }

                            </RadioGroup>
                        </Grid>
                    </Grid>
                }
            </Grid>
        </Grid>
    )
    return (
        <Grid container>
            <Grid item xs={12}>
                <div style={{ textAlign: "center" }}>
                    <h3>Selecciona un metodo de pago</h3>
                </div>
            </Grid>
        </Grid>
    )
}
export default VPagos